module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "活动商品信息",
      "shadow": "never"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动封面"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：750px * 500px）")]), _vm._v(" "), _c('div', [_c('imgBox', {
    attrs: {
      "imgUrl": _vm.wximageurl + _vm.form.pics
    },
    on: {
      "click": _vm.handleImgChange
    }
  })], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "拼团商品"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('p', {
    staticClass: "frm-tips"
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-box"
  }, [_c('div', {
    staticClass: "bran-img"
  }, [(_vm.goods.pics) ? _c('div', {
    staticClass: "groups-addgoods"
  }, [_c('img', {
    staticClass: "groups-goodspic",
    attrs: {
      "src": _vm.wximageurl + _vm.goods.pics[0]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gooups-goodsmsg"
  }, [_c('div', [_vm._v(_vm._s(_vm.goods.itemName))]), _vm._v(" "), _c('div', [_vm._v("原价：" + _vm._s(_vm.goods.price))]), _vm._v(" "), (_vm.goods.item_type == 'normal') ? _c('div', [_vm._v("库存：" + _vm._s(_vm.goods.store))]) : _vm._e()])]) : _c('div', {
    staticClass: "el-upload el-upload--picture-card",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.changeItem
    }
  }, [_vm._v("选择商品")])], 1)])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "act_name",
      "rules": _vm.rules.act_name
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "拼团活动名称"
    },
    model: {
      value: (_vm.form.act_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "act_name", $$v)
      },
      expression: "form.act_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间",
      "prop": "date",
      "rules": _vm.rules.date
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "拼团库存",
      "prop": "store",
      "rules": _vm.rules.store
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.store),
      callback: function($$v) {
        _vm.$set(_vm.form, "store", $$v)
      },
      expression: "form.store"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v(" 件")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "拼团价格",
      "prop": "act_price",
      "rules": _vm.rules.act_price
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.act_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "act_price", $$v)
      },
      expression: "form.act_price"
    }
  }, [_vm._v("元")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v(" 元")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成团人数",
      "prop": "person_num",
      "rules": _vm.rules.person_num
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.person_num),
      callback: function($$v) {
        _vm.$set(_vm.form, "person_num", $$v)
      },
      expression: "form.person_num"
    }
  }, [_vm._v("人")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成团时效",
      "prop": "limit_time",
      "rules": _vm.rules.limit_time
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "小时"
    },
    model: {
      value: (_vm.form.limit_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_time", $$v)
      },
      expression: "form.limit_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("小时")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "限购数量",
      "prop": "limit_buy_num",
      "rules": _vm.rules.limit_buy_num
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.limit_buy_num),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_buy_num", $$v)
      },
      expression: "form.limit_buy_num"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("(限购数量为0表示无限制购买)")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成团机器人"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: (_vm.form.robot),
      callback: function($$v) {
        _vm.$set(_vm.form, "robot", $$v)
      },
      expression: "form.robot"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("(开启成团机器人后，成团时效内人数未满的团，系统将会使用机器人凑满人数，使该团成团。商家只需对真实订单进行发货处理。)")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "凑团"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: (_vm.form.rig_up),
      callback: function($$v) {
        _vm.$set(_vm.form, "rig_up", $$v)
      },
      expression: "form.rig_up"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("(开启凑团后，消费者可以在拼团商品详情页看到未成团的团列表，可选择其中一个参团。有效提高成团成功率)")])], 1)], 1)], 1), _vm._v(" "), (_vm.goods.item_type == 'normal') ? _c('el-form-item', {
    attrs: {
      "label": "包邮"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0"
    },
    model: {
      value: (_vm.form.free_post),
      callback: function($$v) {
        _vm.$set(_vm.form, "free_post", $$v)
      },
      expression: "form.free_post"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("(如果不开启包邮，那么运费按照商品的运费模版计算运费)")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享描述",
      "prop": "share_desc",
      "rules": _vm.rules.share_desc
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 25,
      "placeholder": "请输入拼团活动分享文字"
    },
    model: {
      value: (_vm.form.share_desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "share_desc", $$v)
      },
      expression: "form.share_desc"
    }
  }, [_vm._v("（最多25个字）")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), (true == _vm.show) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitItemsAction('form')
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择商品",
      "visible": _vm.goodsDialogVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.goodsDialogVisible = $event
      }
    }
  }, [_c('el-button-group', {
    staticClass: "tab-group"
  }, [_c('el-button', {
    staticClass: "tab-btn",
    class: _vm.goodsTypeTitle === '服务类商品' ? 'on' : '',
    on: {
      "click": function($event) {
        return _vm.changeGoods('every')
      }
    }
  }, [_vm._v("服务类商品")]), _vm._v(" "), _c('el-button', {
    staticClass: "tab-btn",
    class: _vm.goodsTypeTitle === '实体类商品' ? 'on' : '',
    on: {
      "click": function($event) {
        return _vm.changeGoods('normal')
      }
    }
  }, [_vm._v("实体类商品")])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名称"
    },
    model: {
      value: (_vm.itemsParams.keywords),
      callback: function($$v) {
        _vm.$set(_vm.itemsParams, "keywords", $$v)
      },
      expression: "itemsParams.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.itemsLoading),
      expression: "itemsLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.itemsList,
      "border": "",
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "itemName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "缩略图"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "width": "20",
            "src": _vm.wximageurl + scope.row.pics[0]
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "销售价",
      "formatter": _vm.priceformatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemName",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.form.goods_id != scope.row.itemId) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.chooseItem(scope.row)
            }
          }
        }, [_vm._v("选择")]) : _c('span', [_vm._v("已选择")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.itemsTotalCount > _vm.itemsParams.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.itemsParams.page,
      "total": _vm.itemsTotalCount,
      "page-size": _vm.itemsParams.pageSize
    },
    on: {
      "current-change": _vm.goodsHandleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.itemsParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.itemsParams, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cb59f650", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb59f650"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/groups/add.vue
// module id = 2931
// module chunks = 0